import { render, staticRenderFns } from "./RegPaymentSuccess.vue?vue&type=template&id=d10eadca&"
import script from "./RegPaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./RegPaymentSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports